export default {
  meta: {
    title: '新址报告评分报表',
    url: '/home/config' // 埋点用，记录所属模块
  },
};
